module.exports = __webpack_public_path__ + "static/img/glass-foundation-8m-x-1m_256.286b7a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/glass-foundation-8m-x-1m_256.png
// module id = +hkI
// module chunks = 0